import { inject, Injectable } from '@angular/core';
import { asapScheduler, fromEvent, map } from 'rxjs';
import {
  isLocalStorageKey,
  LOCAL_STORAGE_KEYS_TOKEN,
} from '../models/local-storage-store.models';
import { LocalStorageStore } from '../store/local-storage.store';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageManagementService {
  private readonly localStorageKeys: string[] = inject(
    LOCAL_STORAGE_KEYS_TOKEN
  );
  private readonly localStorageStore = inject(LocalStorageStore);

  private readonly changeLocalStorageContentSubscription =
    fromEvent<StorageEvent>(window, 'storage')
      .pipe(
        map(event => {
          if (isLocalStorageKey(this.localStorageKeys)(event.key)) {
            this.localStorageStore.refreshByKey(event.key);
          }
        })
      )
      .subscribe();

  private readonly initialLocalStorageContentSubscription =
    asapScheduler.schedule(() => this.localStorageStore.refresh());
}
